import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { getActivityItemStateName, getActivityItemStateParams } from '../../core/pipes/activity/activity.functions';
import * as _ from 'lodash';

@Component({
  selector: 'project-activity-timeline',
  template: require('./project.activity.timeline.component.html')
})
export class ProjectActivityTimelineComponent implements OnInit, OnChanges {
  @Input() items: any[] = [];
  @Input() showUser: boolean;
  @Input() showProject: boolean;

  constructor(private stateService: StateService) {}

  processedItems: any[] = [];

  ngOnInit(): void {
    // Defaults showUser ON, showProject OFF
    // In Angular, if showUser isn't set or is undefined, we set it to true
    this.showUser = (this.showUser !== false);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items) {
      this.processedItems = this.transformActivityItems(this.items);
    }
  }

  showActivity(idx: number): boolean {
    const act = this.items[idx];

    // Test? Empty? Ignore such action types
    const allowedTypes = ['create', 'update', 'delete', 'merge'];
    if (!allowedTypes.includes(_.get(act, 'activityType', ''))) {
      return false;
    }

    // Check if same activity, in the same minute
    const prev = idx > 0 ? this.items[idx - 1] : null;
    if (
      _.get(prev, 'section', '') === _.get(act, 'section', '') &&
      _.get(prev, 'refId', '') === _.get(act, 'refId', '') &&
      _.get(prev, 'description', '') === _.get(act, 'description', '')
    ) {
      const d1 = new Date(prev.date);
      const d2 = new Date(act.date);

      if (d2.getTime() - d1.getTime() < 60001) {
        return false;
      }
    }

    return true;
  }

  private transformActivityItems(items: any[]): any[] {
    return _.map(items, (a) => {
      const ext = _.get(a, 'extendedData', '');
      if (!_.isObject(ext) && !_.isEmpty(ext)) {
        try {
          a.extendedData = JSON.parse(ext);
        } catch {
          // Ignore parsing errors
        }
      }
      return a;
    });
  }

  protected getActivityItemUrl(item: any): any {
    return this.stateService.href(getActivityItemStateName(item), getActivityItemStateParams(item));
  }

  trackActivity(index: number, activity: any): any {
    return activity?.id ?? activity;
  }
}
